<template>
    <section>

 
        <div
            style="width:100%;padding-top:20px;padding-bottom:20px;display:flex;justify-content:center; align-items:center;border-radius:15px;">
            <div class="matrix-of-destiny">

                <div id="matrix-form" style="font-family: 'Lato', sans-serif !important;">
                   <div class="mod-form-row">
                        <div class="mod-form-col flex flex-col gap-2.5"> 
                            <label>Día</label>
                            <select v-model="day" id="day" class="  p-3 h-12">
                                <option v-for="n in 31" :key="n" :value="n">{{ n }}</option>                                
                            </select>              
                             
                        </div>
                        <div class="mod-form-col flex flex-col gap-2">
                            <label>Month</label>
                            <select v-model="month" id="month" class="  p-3 h-12">
                                <option v-for="n in 12" :key="n" :value="n">{{ n }}</option>                                
                            </select>
                             
                        </div>
                        <div class="mod-form-col flex flex-col gap-2">
                            <label>Year</label>  
                            <select v-model="year" id="month" class="  p-3 h-12">
                                <option v-for="year in years" :key="year" :value="year">{{ year }}</option>                                
                            </select>                             
                             
                        </div> 
                        <div class="mod-form-col gender-select mt-4">
                            <div class="gender-title mod-form-label">Género:</div>
                            <div class="gender-options">
                                <div class="gender-option male" :class="male==true ? 'active' : ''" @click="tomale">
                                    <i class="fa fa-mars"></i>
                                    <span class="gender-title" >Masculino</span>
                                </div>
                                <div class="gender-option female" :class="female==true ? 'active' : ''" @click="tofemale">
                                    <i class="fa fa-venus"></i>
                                    <span class="gender-title" >Femenino</span>
                                </div>
                            </div>
                        </div>
                        <div class="mod-form-col mt-4">
                            <button @click="Calculat" class="mod-form-button">Calcular</button>
                        </div>
                    </div>
                </div>
                <div class="matrix" id="matrix-container">
                    <!-- Matrix rows and cells will be generated here based on the matrixData -->
                </div>
            </div>
        </div>
        <div v-if="showResult == true"
            class="container flex flex-wrap gap-2.5 lg:gap-8 items-start flex-row-reverse justify-between ">
            <div class="obch w-full md:w-1/3 lg:w-1/2 relative fade mt-24">
                <img src="https://soyhijadelaluna.com/wp-content/uploads/2024/03/schema.png" class="transimage">
                <div id="n1" class="trans" style="position:absolute; width:9%; height:9%; left:1.4%; top:44.6%;">

                    <div style="background:#fff;border:4px solid #B27FAF; width:100%; height:100%; ">
                        <span style=" ">{{ n1
                            }}</span>
                    </div>
                </div>

                <div id="n3" class="trans" style="position:absolute; width:9%; height:9%; left:45.5%; top:1.4%;">

                    <div style="background:#fff;border:4px solid #B27FAF; width:100%; height:100%;  ">
                        <span style=" ">{{ n3
                            }}</span>
                    </div>
                </div>

                <div id="n5" class="trans" style="position:absolute; width:9%; height:9%; left:89.5%; top:44.6%;">

                    <div style="background:#fff;border:4px solid #CB564C; width:100%; height:100%;  ">
                        <span style=" ">{{ n5
                            }}</span>
                    </div>
                </div>

                <div id="n7" class="trans" style="position:absolute; width:9%; height:9%; left:45.4%; top:89%;">

                    <div style="background:#fff;border:4px solid #CB564C; width:100%; height:100%;  ">
                        <span style=" ">{{ n7
                            }}</span>
                    </div>
                </div>

                <div id="n30" class="trans relative" style="position:absolute; width:9%; height:9%; left:45%; top:45%;">

                    <div style="background:#fff;border:4px solid #ffde68; width:100%; height:100%;">
                        <span style=" ">{{
                                n30 }}</span>
                    </div>
                </div>

                <div id="n2" class="trans"
                    style="position:absolute; width:9%; height:9%; left:14.5%; top:14%;  border:3px #ccc  solid; background:#fff;   ">
                    <div style="background:#fff; width:100%; height:100%; ">
                        <span style=" ">{{ n2
                            }}</span>
                    </div>
                </div>

                <div id="n4" class="trans"
                    style="position:absolute; width:9%; height:9%; left:76%; top:14%;  border:3px #ccc  solid; background:#fff;   ">
                    <div style="background:#fff; width:100%; height:100%; ">
                        <span style=" ">{{ n4
                            }}</span>
                    </div>
                </div>

                <div id="n6" class="trans"
                    style="position:absolute; width:9%; height:9%; left:77%; top:75.9%;  border:3px #ccc  solid; background:#fff;   ">
                    <div style="background:#fff; width:100%; height:100%; ">
                        <span style=" ">{{ n6
                            }}</span>
                    </div>
                </div>

                <div id="n8" class="trans"
                    style="position:absolute; width:9%; height:9%; left:14.4%; top:75.5%;  border:3px #ccc  solid; background:#fff;   ">
                    <div style="background:#fff; width:100%; height:100%; ">
                        <span style=" ">{{ n8
                            }}</span>
                    </div>
                </div>

                <div id="n23" class="trans" style="position:absolute; width:4.5%; height:4.5%; left:47.5%; top:76.3%; ">

                    <div style="background:#fff;border:2px solid #e98c46; width:100%; height:100%; ">
                        <span style=" ">{{ n15
                            }}</span>
                    </div>
                </div>

                <div id="n21" class="trans" style="position:absolute; width:4.5%; height:4.5%; left:77%; top:47.3%;  ">

                    <div style="background:#fff;border:2px solid #e98c46; width:100%; height:100%; ">
                        <span style=" ">{{ n21
                            }}</span>
                    </div>
                </div>

                <div id="n28" class="trans"
                    style="position:absolute; width:4.5%; height:4.5%; left:61%; top:60.5%;  border:2px #ccc  solid; background:#fff;">

                    <div style="background:#fff; width:100%; height:100%; ">
                        <span style=" ">{{ n28
                            }}</span>
                    </div>
                </div>

                <div id="n29" class="trans"
                    style="position:absolute; width:4.5%; height:4.5%; left:58.5%; top:66.5%;  border:2px #ccc  solid; background:#fff;   ">

                    <div style="background:#fff; width:100%; height:100%; ">
                        <span style=" ">{{ n29
                            }}</span>
                    </div>
                </div>

                <div id="n17" class="trans" style="position:absolute; width:4.5%; height:4.5%; left:17.5%; top:46.8%; ">

                    <div style="background:#fff;border: 2px solid #00b8f4; width:100%; height:100%; ">
                        <span style=" ">{{ n17
                            }}</span>
                    </div>
                </div>

                <div id="n19" class="trans" style="position:absolute; width:4.5%; height:4.5%; left:47.4%; top:17.5%;">

                    <div style="background:#fff;border:2px solid #00b8f4; width:100%; height:100%; ">
                        <span style=" ">{{ n19
                            }}</span>
                    </div>
                </div>

                <div id="n15" class="trans"
                    style="position:absolute; width:5.5%; height:5.5%; left:46.9%; top:82%;  border:2px #ccc  solid; background:#fff;   ">
                    <div style="background:#fff; width:100%; height:100%; ">
                        <span style=" ">{{ n23
                            }}</span>
                    </div>
                </div>

                <div id="n11" class="trans" style="position:absolute; width:5.5%; height:5.5%; left:46.9%; top:11%; ">

                    <div style="background:#fff;border:2px solid #0067d2; width:100%; height:100%; ">
                        <span style=" ">{{ n11
                            }}</span>
                    </div>
                </div>

                <div id="n13" class="trans"
                    style="position:absolute; width:5.5%; height:5.5%; left:82.8%; top:46.5%;  border:2px #ccc  solid; background:#fff;   ">

                    <div style="background:#fff; width:100%; height:100%; ">
                        <span style=" ">{{ n13
                            }}</span>
                    </div>
                </div>

                <div id="n25" class="trans" style="position:absolute; width:4.5%; height:4.5%; left:32%; top:47.3%;">
                    <div style="background:#fff;border:2px solid #63b062; width:100%; height:100%; ">
                        <span style=" ">{{ n25
                            }}</span>
                    </div>
                </div>

                <div id="n26" class="trans" style="position:absolute; width:4.5%; height:4.5%; left:47.6%; top:31%;">
                    <div style="background:#fff;border:2px solid #63b062; width:100%; height:100%; ">
                        <span style=" ">{{ n26
                            }}</span>
                    </div>
                </div>

                <div id="n9" class="trans" style="position:absolute; width:5.5%; height:5.5%; left:10.9%; top:46.1%;">

                    <div style="background:#fff;border:2px solid #0067d2; width:100%; height:100%; ">
                        <span style=" ">{{ n9
                            }}</span>
                    </div>
                </div>

                <div id="n18" class="trans"
                    style="position:absolute; width:4.5%; height:4.5%; left:26.8%; top:26.2%;  border:2px #ccc  solid; background:#fff;   ">
                    <div style="background:#fff; width:100%; height:100%; ">
                        <span style=" ">{{ n18
                            }}</span>
                    </div>
                </div>

                <div id="n10" class="trans"
                    style="position:absolute; width:5.5%; height:5.5%; left:21.9%; top:21.9%;  border:2px #ccc  solid; background:#fff;   ">
                    <div style="background:#fff; width:100%; height:100%; ">
                        <span style=" ">{{ n10
                            }}</span>
                    </div>
                </div>

                <div id="n20" class="trans"
                    style="position:absolute; width:4.5%; height:4.5%; left:68.8%; top:26.2%;  border:2px #ccc  solid; background:#fff;   ">
                    <div style="background:#fff; width:100%; height:100%; ">
                        <span style=" ">{{ n20
                            }}</span>
                    </div>
                </div>

                <div id="n12" class="trans"
                    style="position:absolute; width:5.5%; height:5.5%; left:72.5%; top:21.9%;  border:2px #ccc  solid; background:#fff;   ">
                    <div style="background:#fff; width:100%; height:100%; ">
                        <span style=" ">{{ n12
                            }}</span>
                    </div>
                </div>

                <div id="n22" class="trans"
                    style="position:absolute; width:4.5%; height:4.5%; left:68.3%; top:67.9%;  border:2px #ccc  solid; background:#fff;   ">
                    <div style="background:#fff; width:100%; height:100%; ">
                        <span style=" ">{{ n22
                            }}</span>
                    </div>
                </div>

                <div id="n14" class="trans"
                    style="position:absolute; width:5.5%; height:5.5%; left:72%; top:71.7%;  border:2px #ccc  solid; background:#fff;   ">
                    <div style="background:#fff; width:100%; height:100%; ">
                        <span style=" ">{{ n14
                            }}</span>
                    </div>
                </div>

                <div id="n24" class="trans"
                    style="position:absolute; width:4.5%; height:4.5%; left:26.8%; top:67.9%;  border:2px #ccc  solid; background:#fff;   ">
                    <div style="background:#fff; width:100%; height:100%; ">
                        <span style=" ">{{ n24
                            }}</span>
                    </div>
                </div>

                <div id="n16" class="trans"
                    style="position:absolute; width:5.5%; height:5.5%; left:21.9%; top:71.4%;  border:2px #ccc  solid; background:#fff;   ">
                    <div style="background:#fff; width:100%; height:100%; ">
                        <span style=" ">{{ n16
                            }}</span>
                    </div>
                </div>

                <div id="n27" class="trans"
                    style="position:absolute; width:4.5%; height:4.5%; left:67%; top:58.5%;  border:2px #ccc  solid; background:#fff;   ">
                    <div style="background:#fff; width:100%; height:100%; ">

                        <span style=" ">{{ n27
                            }}</span>
                    </div>
                </div>


                <div id="n32" class="trans"
                    style="position:absolute; width:5.5%; height:5.5%; left:61%; top:46.9%;  border:2px #ccc  solid; background:#FFFFFF;    ">
                    <div style=" width:100%; height:100%;  "><span
                            style=" "> {{ n32 }}
                        </span>
                    </div>
                </div>


                <div id="n31" class="trans"
                    style="position:absolute; width:6.5%; height:6.5%; left:54.3%; top:46.1%;  border:2px #ccc  solid; background:#FFFFFF;    ">
                    <div style=" width:100%; height:100%;  ">
                        <span style=" ">{{ n31
                            }}</span>
                    </div>
                </div>



                <!-- 0 - 10 -->
                <div class="trans" style="position:absolute; top:30.3%; left:3.5%; height:3%; width:5%;">
                    <span style=" ">{{ y1 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:36.5%; left:1%; height:3%; width:5%;">
                    <span style=" ">{{ y2 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:39.5%; left:0%; height:3%; width:5%;">
                    <span style=" ">{{ y3 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:33.5%; left:2%; height:3%; width:5%;">
                    <span style=" ">{{ y4 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:24.3%; left:6.2%; height:3%; width:5%;">
                    <span style=" ">{{ y5 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:21.1%; left:7.6%; height:3%; width:5%;">
                    <span style=" ">{{ y6 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:27.3%; left:4.7%; height:3%; width:5%;">
                    <span style=" ">{{ y7 }}</span>
                </div>
                <!-- 10 - 20 -->
                <div class="trans" style="position:absolute; top:4.2%; left:29.7%; height:3%; width:5%;">
                    <span style=" ">{{ y8 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:7.0%; left:23.5%; height:3%; width:5%;">
                    <span style=" ">{{ y9 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:8.5%; left:20%; height:3%; width:5%;">
                    <span style=" ">{{ y10 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:5.3%; left:26.5%; height:3%; width:5%;">
                    <span style=" ">{{ y11 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:2.0%; left:36%; height:3%; width:5%;">
                    <span style=" ">{{ y12 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:1.0%; left:39.5%; height:3%; width:5%;">
                    <span style=" ">{{ y13 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:2.8%; left:33%; height:3%; width:5%;">
                    <span style=" ">{{ y14 }}</span>
                </div>
                <!-- 20 - 30 -->
                <div class="trans" style="position:absolute; top:3.9%; left:65.6%; height:3%; width:5%;">
                    <span style=" ">{{ y15 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:1.6%; left:59.7%; height:3%; width:5%;">
                    <span style=" ">{{ y16 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:0.6%; left:55.3%; height:3%; width:5%;">
                    <span style=" ">{{ y17 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:2.8%; left:63%; height:3%; width:5%;">
                    <span style=" ">{{ y18 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:6.7%; left:71.3%; height:3%; width:5%;">
                    <span style=" ">{{ y19 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:5.6%; left:68.5%; height:3%; width:5%;">
                    <span style=" ">{{ y20 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:7.6%; left:74.6%; height:3%; width:5%;">
                    <span style=" ">{{ y21 }}</span>
                </div>
                <!-- 30 - 40 -->
                <div class="trans" style="position:absolute; top:29.4%; left:91.6%; height:3%; width:5%;">
                    <span style=" ">{{ y22 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:23.3%; left:89.0%; height:3%; width:5%;">
                    <span style=" ">{{ y23 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:20.1%; left:87.2%; height:3%; width:5%;">
                    <span style=" ">{{ y24 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:26.1%; left:90.0%; height:3%; width:5%;">
                    <span style=" ">{{ y25 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:35.5%; left:94%; height:3%; width:5%;">
                    <span style=" ">{{ y26 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:39.2%; left:95.3%; height:3%; width:5%;">
                    <span style=" ">{{ y27 }}</span>
                </div>
                <div class="trans" style="position:absolute; top:32.5%; left:92.6%; height:3%; width:5%;">
                    <span style=" ">{{ y28 }}</span>
                </div>
                <!-- 40 - 50 -->
                <!-- 40 - 50 -->
                <div class="trans" style="position:absolute; top:65%; left:91.5%; height:3%; width:5%;">
                    <span style=" " id="y29">{{ y29
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:59%; left:93.5%; height:3%; width:5%;">
                    <span style=" " id="y30">{{ y30
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:62%; left:92.5%; height:3%; width:5%;">
                    <span style=" " id="y31">{{ y31
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:55.6%; left:95%; height:3%; width:5%;">
                    <span style=" " id="y32">{{ y32
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:71.5%; left:88%; height:3%; width:5%;">
                    <span style=" " id="y33">{{ y33
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:74.4%; left:87%; height:3%; width:5%;">
                    <span style=" " id="y34">{{ y34
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:68.3%; left:90%; height:3%; width:5%;">
                    <span style=" " id="y35">{{ y35
                        }}</span>
                </div>
                <!-- 50 - 60 -->
                <div class="trans" style="position:absolute; top:92%; left:65%; height:3%; width:5%;">
                    <span style=" " id="y36">{{ y36
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:89%; left:71.7%; height:3%; width:5%;">
                    <span style=" " id="y37">{{ y37
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:88%; left:75.0%; height:3%; width:5%;">
                    <span style=" " id="y38">{{ y38
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:90.5%; left:68.7%; height:3%; width:5%;">
                    <span style=" " id="y39">{{ y39
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:94.5%; left:59%; height:3%; width:5%;">
                    <span style=" " id="y40">{{ y40
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:93%; left:62%; height:3%; width:5%;">
                    <span style=" " id="y41">{{ y41
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:96%; left:55%; height:3%; width:5%;">
                    <span style=" " id="y42">{{ y42
                        }}</span>
                </div>
                <!-- 60 - 70 -->
                <div class="trans" style="position:absolute; top:92.0%; left:30%; height:3%; width:5%;">
                    <span style=" " id="y43">{{ y43
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:94.5%; left:36.5%; height:3%; width:5%;">
                    <span style=" " id="y44">{{ y44
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:96.0%; left:39.5%; height:3%; width:5%;">
                    <span style=" " id="y45">{{ y45
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:93.3%; left:33.3%; height:3%; width:5%;">
                    <span style=" " id="y46">{{ y46
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:89.5%; left:23.5%; height:3%; width:5%;">
                    <span style=" " id="y47">{{ y47
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:91.0%; left:26.5%; height:3%; width:5%;">
                    <span style=" " id="y48">{{ y48
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:88.0%; left:20.5%; height:3%; width:5%;">
                    <span style=" " id="y49">{{ y49
                        }}</span>
                </div>
                <!-- 70 - 80 -->
                <div class="trans" style="position:absolute; top:65.3%; left:3.0%; height:3%; width:5%;">
                    <span style=" " id="y50">{{ y50
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:72%; left:6.0%; height:3%; width:5%;">
                    <span style=" " id="y51">{{ y51
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:75%; left:7.4%; height:3%; width:5%;">
                    <span style=" " id="y52">{{ y52
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:68.5%; left:5.0%; height:3%; width:5%;">
                    <span style=" " id="y53">{{ y53
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:59%; left:1.0%; height:3%; width:5%;">
                    <span style=" " id="y54">{{ y54
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:56%; left:-1%; height:3%; width:5%;">
                    <span style=" " id="y55">{{ y55
                        }}</span>
                </div>
                <div class="trans" style="position:absolute; top:62%; left:2.0%; height:3%; width:5%;">
                    <span style=" " id="y56">{{ y56
                        }}</span>
                </div>

            </div>

            <div class="w-full lg:w-1/3 text-gray-900 mt-8 lg:mt-24">

                <table class="table text-gray-900" width="100%">
                    <tbody>
                        <tr class=" p-3 h-14 font-bold" style="background:#c1a3bd;">
                            <td></td>
                            <td class="pl-4 explanation-item">Chakra</td>
                            <td> Cuerpo </td>
                            <td> Energía </td>
                            <td> Emociones </td>
                        </tr>
                        <tr class=" " style="background:#F7F3F6;">
                            <td style=" "> <img src="https://soyhijadelaluna.com/wp-content/uploads/2024/03/rosa.png"
                                    style="width:50px;position:relative;right:8px;bottom:10px;" alt="icon" /></td>
                            <td class="trans" id="chakra7" style="border-right:2px solid #fff; "><span
                                    class="td_chakra py-5" style="display:flex;gap:15px;align-items:center;">
                                    <div style="display:flex;flex-direction:column;gap:5px;align-items:flex-start;">
                                        <span style="font-size:16px; ">Sahasrara</span> </div>
                                </span></td>
                            <td class="trans" id="n33" style="border-right:2px solid #fff;text-align:center ">{{ n33 }}
                            </td>
                            <td class="trans" id="n34" style="border-right:2px solid #fff;text-align:center ">{{ n34 }}
                            </td>
                            <td class="trans" id="n35" style="text-align:center;">{{ n35 }}
                            </td>
                        </tr>
                        <tr class="p-3" style="background:#F0E9FF;">
                            <td> <img src="https://soyhijadelaluna.com/wp-content/uploads/2024/03/violet.png" style="width:50px;position:relative;right:8px;bottom:10px;"
                                    alt="icon" /></td>
                            <td class="trans" id="chakra6" style="border-right:2px solid #fff; "><span
                                    class="td_chakra py-5" style="display:flex;gap:15px;align-items:center;">
                                    <div style="display:flex;flex-direction:column;gap:5px;align-items:flex-start;">
                                        <span style="font-size:16px; ">Ajna</span> </div>
                                </span></td>
                            <td class="trans" id="n36" style="border-right:2px solid #fff; text-align:center">{{ n36 }}
                            </td>
                            <td class="trans" id="n37" style="border-right:2px solid #fff; text-align:center">{{ n37 }}
                            </td>
                            <td class="trans" id="n38" style="text-align:center">{{ n38 }}
                            </td>
                        </tr>
                        <tr class="p-3" style="background:#EAFBFB;">
                            <td> <img src="https://soyhijadelaluna.com/wp-content/uploads/2024/03/green.png" style="width:50px;position:relative;right:8px;bottom:10px;"
                                    alt="icon" /></td>
                            <td class="trans" id="chakra5" style="border-right:2px solid #fff; "><span
                                    class="td_chakra py-6" style="display:flex;gap:15px;align-items:center;">
                                    <div style="display:flex;flex-direction:column;gap:5px;align-items:flex-start;">
                                        <span style="font-size:16px; ">Vishuddha</span> </div>
                                </span></td>
                            <td class="trans" id="n39" style="border-right:2px solid #fff; text-align:center">{{ n39 }}
                            </td>
                            <td class="trans" id="n40" style="border-right:2px solid #fff;text-align:center ">{{ n40 }}
                            </td>
                            <td class="trans" id="n41" style="text-align:center">{{ n41 }}
                            </td>
                        </tr>
                        <tr class="  p-3" style="background:#F3FBF7;">
                            <td style=" "> <img src="https://soyhijadelaluna.com/wp-content/uploads/2024/03/lightgreen.png"
                                    style="width:50px;position:relative;right:8px;bottom:10px;" alt="icon" /></td>
                            <td class="trans" id="chakra4" style="border-right:2px solid #fff; "><span
                                    class="td_chakra py-5" style="display:flex;gap:15px;align-items:center;">
                                    <div style="display:flex;flex-direction:column;gap:5px;align-items:flex-start;">
                                        <span style="font-size:16px; ">Anahata</span>
                                    </div>
                                </span></td>
                            <td class="trans" id="n42" style="border-right:2px solid #fff; text-align:center">{{ n42 }}
                            </td>
                            <td class="trans" id="n43" style="border-right:2px solid #fff;text-align:center ">{{ n43 }}
                            </td>
                            <td class="trans" id="n44" style="text-align:center">{{ n44 }}
                            </td>
                        </tr>
                        <tr class=" p-3" style="background:#FEFAF4;">
                            <td style=" "> <img src="https://soyhijadelaluna.com/wp-content/uploads/2024/03/orange.png"
                                    style="width:50px;position:relative;right:8px;bottom:10px;" alt="icon" /></td>
                            <td class="trans" id="chakra3" style="border-right:2px solid #fff; "><span
                                    class="td_chakra py-5" style="display:flex;gap:15px;align-items:center;">
                                    <div style="display:flex;flex-direction:column;gap:5px;align-items:flex-start;">
                                        <span style="font-size:16px; ">Manipura</span> </div>
                                </span></td>
                            <td class="trans" id="n45" style="border-right:2px solid #fff; text-align:center">{{ n45 }}
                            </td>
                            <td class="trans" id="n46" style="border-right:2px solid #fff;text-align:center ">{{ n46 }}
                            </td>
                            <td class="trans" id="n47" style="text-align:center">{{ n47 }}
                            </td>
                        </tr>
                        <tr class=" p-3" style="background:#FDF1EE">
                            <td style=" "> <img src="https://soyhijadelaluna.com/wp-content/uploads/2024/03/tenseorange.png"
                                    style="width:50px;position:relative;right:8px;bottom:10px;" alt="icon" /></td>
                            <td class="trans" id="chakra2" style="border-right:2px solid #fff; "><span
                                    class="td_chakra py-5" style="display:flex;gap:15px;align-items:center;">
                                    <div style="display:flex;flex-direction:column;gap:5px;align-items:flex-start;">
                                        <span style="font-size:16px; ">Svadhisthana</span> </div>
                                </span></td>
                            <td class="trans " id="n48" style="border-right:2px solid #fff;text-align:center ">{{ n48 }}
                            </td>
                            <td class="trans" id="n49" style="border-right:2px solid #fff;text-align:center ">{{ n49 }}
                            </td>
                            <td class="trans" id="n50" style="text-align:center">{{ n50 }}
                            </td>
                        </tr>
                        <tr class=" p-3" style="background:#FFEAEA; ">
                            <td> <img src="https://soyhijadelaluna.com/wp-content/uploads/2024/03/red.png" style="width:50px;position:relative;right:8px;bottom:10px;"
                                    alt="icon" /></td>
                            <td class="trans" id="chakra1" style="border-right:2px solid #fff; "><span
                                    class="td_chakra py-5" style="display:flex;gap:15px;align-items:center;">
                                    <div style="display:flex;flex-direction:column;gap:5px;align-items:flex-start;">
                                        <span style="font-size:16px; ">Muladhara</span> </div>
                                </span></td>
                            <td class="trans" id="n51" style="border-right:2px solid #fff;text-align:center ">{{ n51 }}
                            </td>
                            <td class="trans" id="n52" style="border-right:2px solid #fff;text-align:center ">{{ n52 }}
                            </td>
                            <td class="trans" id="n53" style="text-align:center">{{ n53 }}
                            </td>
                        </tr>
                       <tr class=" p-2 pb-4 h-14" style="background:#C6C8D4;">
                            <td></td>
                            <td class="trans" id="chakra"><span class="td_chakra p-3"
                                    style="display:flex; align-items:center;">
                                    <div style="display:flex;flex-direction:column;gap:5px;align-items:flex-start;position:relative;
                                    right:15px;"><span
                                            style="font-size:16px;font-weight:bold">
                                            Resultado</span><span style="font-size:13px;text-align:left;">Campo energético
                                            general</span></div>
                                </span></td>
                            <td class="trans" id="n54" style="text-align:center">{{ n54 }}
                            </td>
                            <td class="trans" id="n55" style="text-align:center">{{ n55 }}
                            </td>
                            <td class="trans" id="n56" style="text-align:center">{{ n56 }}
                            </td>
                        </tr>  
                    </tbody>
                </table>
            </div>
            <div class="w-full">

                <div class="flex flex-wrap justify-center  mt-12 px-12 lg:px-2">

                    <!-- <div class="flex gap-4  w-full  mb-4 items-center">
                        <p>Programas ancestrales por la línea paterna:</p>
                        <div class="flex gap-0.5">
                            <div class="round trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center"
                                id="n61">{{ n2 }}</div>
                            <div class="round trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center"
                                id="n61">{{ n6 }}</div>
                            <div class="round trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center"
                                id="n61">{{ n64 }}</div>
                        </div>
                    </div> -->

                    <!-- <div class="flex gap-4  w-full mb-4 items-center">
                        <p>Programas ancestrales por la línea materna:</p>
                        <div class="flex gap-0.5">
                            <div class="round trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center"
                                id="n61">{{ n4 }}</div>
                            <div class="round trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center"
                                id="n61">{{ n8 }}</div>
                            <div class="round trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center"
                                id="n61">{{ n65 }}</div>
                        </div>
                    </div> -->
                    <div class="flex items-start justify-center flex-wrap mt-12 w-full gap-5 lg:gap-0">
                        <div class="flex flex-col gap-6 w-full lg:w-1/4 justify-between">

                            <div class="flex items-center flex-col ">
                                <div style="font-size:17px;  margin-bottom:5px; padding:12px; background:#c1a3bd;">
                                    Propósito Personal
                                </div>

                            </div>
                            <div class="flex justify-center gap-0.5 items-center">
                                <div>
                                    <div class="flex items-center justify-between gap-2.5">
                                        <p>Cielo </p>
                                        <span
                                            class="round trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center"
                                            id="n57">{{ n57 }}</span>
                                    </div>
                                    <div class="flex items-center justify-between gap-2.5">
                                        <p>Tierra</p>
                                        <span
                                            class="round trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center"
                                            id="n59">{{ n59 }}</span>
                                    </div>
                                </div>

                                <img src="https://soyhijadelaluna.com/wp-content/uploads/2024/03/curlybraces.png" alt="curly" style="width:30px;" />
                                <div class="round trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center"
                                    id="n58">{{ n58 }}</div>
                            </div>
                        </div>

                        <div class="flex flex-col gap-6 w-full lg:w-1/4 justify-between">
                            <div class="flex items-center flex-col ">
                                <div style="font-size:17px;  margin-bottom:5px;padding:12px; background:#c1a3bd;">
                                    Propósito Social
                                </div>

                            </div>
                            <div class="flex justify-center gap-0.5 items-center">
                                <div>
                                    <div class="flex items-center justify-between gap-2.5">
                                        <p>Linaje Materno</p>
                                        <span
                                            class="round trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center"
                                            id="n60">{{ n60 }}</span>
                                    </div>
                                    <div class="flex items-center justify-between gap-2.5">
                                        <p>Linaje Paterno</p>
                                        <span
                                            class="round trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center"
                                            id="n62">{{ n62 }}</span>
                                    </div>
                                </div>
                                <img src="https://soyhijadelaluna.com/wp-content/uploads/2024/03/curlybraces.png" alt="curly" style="width:30px;" />
                                <div class="round trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center"
                                    id="n61">{{ n61 }}</div>
                            </div>
                        </div>

                        <div class="flex flex-wrap lg:flex-nowrap gap-2.5  w-full lg:w-1/4">
                            <div class="flex flex-col gap-2.5 w-full">
                                <div class="flex gap-2.5 items-center justify-center">
                                    <span style="font-size:17px;  padding:12px; background:#c1a3bd; ">Propósito Espiritual</span>

                                </div>

                                <span
                                    class="round  trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center mx-auto"
                                    id="n63">{{ n63 }}</span>
                            </div>
                        </div>

                        <div class="flex flex-wrap lg:flex-nowrap gap-2.5  w-full lg:w-1/4">
                            <div class="flex flex-col gap-2.5 w-full">
                                <div class="flex gap-2.5 items-center justify-center">
                                    <span style="font-size:17px;  padding:12px; background:#c1a3bd; ">Propósito Planetario</span>

                                </div>

                                <span
                                    class="round  trans rounded-full border-2 w-12 h-12 border-gray-900 flex justify-center items-center mx-auto"
                                    id="n63">{{ n7 }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Email e botão -->
 

    </section>
</template>

<script>
 

export default {

    data() {
        return {
            male: false,
            female: false, 
            currentYear: new Date().getFullYear(),         
            values: 0,
            day: 1,
            month: 10,
            year: 1990,
            n1: 0,
            n3: 0,
            n5: 0,
            n2: 0,
            n4: 0,
            n6: 0,
            n7: 0,
            n8: 0,
            n9: 0,
            n10: 0,
            n11: 0,
            n12: 0,
            n13: 0,
            n14: 0,
            n15: 0,
            n16: 0,
            n17: 0,
            n18: 0,
            n19: 0,
            n20: 0,
            n21: 0,
            n22: 0,
            n23: 0,
            n24: 0,
            n25: 0,
            n26: 0,
            n27: 0,
            n28: 0,
            n29: 0,
            n30: 0,
            n31: 0,
            n32: 0,
            y1: 0,
            y2: 0,
            y3: 0,
            y4: 0,
            y5: 0,
            y6: 0,
            y7: 0,
            y8: 0,
            y9: 0,
            y10: 0,
            y11: 0,
            y12: 0,
            y13: 0,
            y14: 0,
            y15: 0,
            y16: 0,
            y17: 0,
            y18: 0,
            y19: 0,
            y20: 0,
            y21: 0,
            y22: 0,
            y23: 0,
            y24: 0,
            y25: 0,
            y26: 0,
            y27: 0,
            y28: 0,
            y29: 0,
            y30: 0,
            y31: 0,
            y32: 0,
            y33: 0,
            y34: 0,
            y35: 0,
            y36: 0,
            y37: 0,
            y38: 0,
            y39: 0,
            y40: 0,
            y41: 0,
            y42: 0,
            y43: 0,
            y44: 0,
            y45: 0,
            y46: 0,
            y47: 0,
            y48: 0,
            y49: 0,
            y50: 0,
            y51: 0,
            y52: 0,
            y53: 0,
            y54: 0,
            y55: 0,
            y56: 0,
            n33: 0,
            n34: 0,
            n35: 0,
            n36: 0,
            n37: 0,
            n38: 0,
            n39: 0,
            n40: 0,
            n41: 0,
            n42: 0,
            n43: 0,
            n44: 0,
            n45: 0,
            n46: 0,
            n47: 0,
            n48: 0,
            n49: 0,
            n50: 0,
            n51: 0,
            n52: 0,
            n53: 0,
            n54: 0,
            n55: 0,
            n56: 0,
            n57: 0,
            n58: 0,
            n59: 0,
            n60: 0,
            n61: 0,
            n62: 0,
            n63: 0,
            n64: 0,
            n65: 0,
        }
    },
    computed: {
    years() {
      const startYear = this.currentYear - 124; 
      const endYear = this.currentYear; 
      let yearsArray = [];
      for (let i = startYear; i <= endYear; i++) {
        yearsArray.push(i);
      }
      return yearsArray;
    }
  },
    methods: {

        tomale(){
            this.male = true;
            this.female = false;
        },
        tofemale(){
           this.female = true;
           this.male = false;
        },

        IfIsMoreThan22(value) {
            if (value > 22) {
                this.values = value.toString().split('').map(Number);
                value = this.values.reduce((a, b) => b + a);

                if (value < 22) {
                    return value;
                } else {

                    if(value == 22){
                        return value
                    }else {
                        this.values = value.toString().split('').map(Number);
                    value = this.values.reduce((a, b) => b + a);
                    return value;
                    }
                   
                }

            } else {
                return value;
            }
        },
        TheN1() {
            this.n1 = this.IfIsMoreThan22(this.day);
        },

        TheN5() {
            this.n5 = this.IfIsMoreThan22(this.year);
        },

        TheN3() {
            this.n3 = this.IfIsMoreThan22(this.month);
        },

        TheN7() {
            this.n7 = this.IfIsMoreThan22(this.n1 + this.n5 + this.n3);
        },

        TheD() {
            this.n30 = this.IfIsMoreThan22(this.n1 + this.n5 + this.n3 + this.n7);
        },
        TheN17() {

            this.n17 = this.IfIsMoreThan22(this.n30 + this.n1);
        },
        TheN19() {
            this.n19 = this.IfIsMoreThan22(this.n3 + this.n30);
        },

        TheN21() {
            this.n21 = this.IfIsMoreThan22(this.n5 + this.n30);
        },



        TheN9() {
            this.n9 = this.IfIsMoreThan22(this.n1 + this.n17);
        },

        TheN11() {
            this.n11 = this.IfIsMoreThan22(this.n19 + this.n3);
        },
        TheN13() {
            this.n13 = this.IfIsMoreThan22(this.n5 + this.n21);
        },



        TheN2() {
            this.n2 = this.IfIsMoreThan22(this.n1 + this.n3);
        },

        TheN4() {
            this.n4 = this.IfIsMoreThan22(this.n5 + this.n3);
        },

        TheN6() {
            this.n6 = this.IfIsMoreThan22(this.n5 + this.n7);
        },

        TheN8() {
            this.n8 = this.IfIsMoreThan22(this.n1 + this.n7);
        },

        TheN26() {
            this.n26 = this.IfIsMoreThan22(this.n19 + this.n30);
        },

        TheN25() {
            this.n25 = this.IfIsMoreThan22(this.n17 + this.n30);
        },


        TheN31() {
            this.n31 = this.IfIsMoreThan22(this.n2 + this.n4 + this.n6 + this.n8);
        },

        TheN32() {
            this.n32 = this.IfIsMoreThan22(this.n30 + this.n31);
        },

        TheN18() {
            this.n18 = this.IfIsMoreThan22(this.n2 + this.n31);
        },

        TheN20() {
            this.n20 = this.IfIsMoreThan22(this.n4 + this.n31);
        },

        TheN12() {
            this.n12 = this.IfIsMoreThan22(this.n4 + this.n20);
        },

        TheN22() {
            this.n22 = this.IfIsMoreThan22(this.n6 + this.n31);
        },

        TheN14() {
            this.n14 = this.IfIsMoreThan22(this.n6 + this.n22);
        },


        TheN24() {
            this.n24 = this.IfIsMoreThan22(this.n8 + this.n31);
        },

        TheN16() {
            this.n16 = this.IfIsMoreThan22(this.n8 + this.n24);
        },



        TheN10() {
            this.n10 = this.IfIsMoreThan22(this.n2 + this.n18);
        },
        TheN15() {
            this.n15 = this.IfIsMoreThan22(this.n7 + this.n30);
        },

        TheN23() {
            this.n23 = this.IfIsMoreThan22(this.n7 + this.n15);
        },

        TheN28() {
            this.n28 = this.IfIsMoreThan22(this.n15 + this.n21);
        },


        TheN29() {
            this.n29 = this.IfIsMoreThan22(this.n28 + this.n15);
        },


        TheN27() {
            this.n27 = this.IfIsMoreThan22(this.n28 + this.n21);
        },


        //calculating years

        TheY1() {
            this.y1 = this.IfIsMoreThan22(this.n1 + this.n2);
        },

        TheY2() {
            this.y2 = this.IfIsMoreThan22(this.n1 + this.y1);
        },

        TheY3() {
            this.y3 = this.IfIsMoreThan22(this.n1 + this.y2);
        },

        TheY4() {
            this.y4 = this.IfIsMoreThan22(this.y1 + this.y2);
        },

        TheY5() {
            this.y5 = this.IfIsMoreThan22(this.y1 + this.n2);
        },

        TheY7() {
            this.y7 = this.IfIsMoreThan22(this.y1 + this.y5);
        },

        TheY6() {
            this.y6 = this.IfIsMoreThan22(this.y5 + this.n2);
        },

        TheY8() {
            this.y8 = this.IfIsMoreThan22(this.n3 + this.n2);
        },

        TheY9() {
            this.y9 = this.IfIsMoreThan22(this.y8 + this.n2);
        },

        TheY10() {
            this.y10 = this.IfIsMoreThan22(this.y9 + this.n2);
        },

        TheY11() {
            this.y11 = this.IfIsMoreThan22(this.y9 + this.y8);
        },

        TheY12() {
            this.y12 = this.IfIsMoreThan22(this.n3 + this.y8);
        },

        TheY13() {
            this.y13 = this.IfIsMoreThan22(this.month + this.y12);
        },

        TheY14() {
            this.y14 = this.IfIsMoreThan22(this.y8 + this.y12);
        },

        TheY15() {
            this.y15 = this.IfIsMoreThan22(this.month + this.n4);
        },

        TheY16() {
            this.y16 = this.IfIsMoreThan22(this.month + this.y15);
        },

        TheY17() {
            this.y17 = this.IfIsMoreThan22(this.month + this.y16);
        },

        TheY18() {
            this.y18 = this.IfIsMoreThan22(this.y15 + this.y16);
        },

        TheY19() {
            this.y19 = this.IfIsMoreThan22(this.y15 + this.n4);
        },

        TheY20() {
            this.y20 = this.IfIsMoreThan22(this.y15 + this.y19);
        },

        TheY21() {
            this.y21 = this.IfIsMoreThan22(this.n4 + this.y19);
        },

        TheY22() {
            this.y22 = this.IfIsMoreThan22(this.n5 + this.n4);
        },

        TheY23() {
            this.y23 = this.IfIsMoreThan22(this.y22 + this.n4);
        },

        TheY24() {
            this.y24 = this.IfIsMoreThan22(this.y23 + this.n4);
        },

        TheY25() {
            this.y25 = this.IfIsMoreThan22(this.y23 + this.y22);
        },

        TheY26() {
            this.y26 = this.IfIsMoreThan22(this.n5 + this.y22);
        },

        TheY27() {
            this.y27 = this.IfIsMoreThan22(this.n5 + this.y26);
        },

        TheY28() {
            this.y28 = this.IfIsMoreThan22(this.y22 + this.y26);
        },

        TheY29() {
            this.y29 = this.IfIsMoreThan22(this.n6 + this.n5);
        },

        TheY30() {
            this.y30 = this.IfIsMoreThan22(this.y29 + this.n5);
        },

        TheY31() {
            this.y31 = this.IfIsMoreThan22(this.y29 + this.y30);
        },

        TheY32() {
            this.y32 = this.IfIsMoreThan22(this.n5 + this.y30);
        },

        TheY33() {
            this.y33 = this.IfIsMoreThan22(this.n6 + this.y29);
        },

        TheY34() {
            this.y34 = this.IfIsMoreThan22(this.n6 + this.y33);
        },

        TheY35() {
            this.y35 = this.IfIsMoreThan22(this.y29 + this.y33);
        },

        TheY36() {
            this.y36 = this.IfIsMoreThan22(this.n6 + this.n7);
        },

        TheY37() {
            this.y37 = this.IfIsMoreThan22(this.n6 + this.y36);
        },

        TheY38() {
            this.y38 = this.IfIsMoreThan22(this.n6 + this.y37);
        },

        TheY39() {
            this.y39 = this.IfIsMoreThan22(this.y36 + this.y37);
        },

        TheY40() {
            this.y40 = this.IfIsMoreThan22(this.y36 + this.n7);
        },

        TheY41() {
            this.y41 = this.IfIsMoreThan22(this.y36 + this.y40);
        },

        TheY42() {
            this.y42 = this.IfIsMoreThan22(this.n7 + this.y40);
        },

        TheY43() {
            this.y43 = this.IfIsMoreThan22(this.n7 + this.n8);
        },

        TheY44() {
            this.y44 = this.IfIsMoreThan22(this.n7 + this.y43);
        },

        TheY45() {
            this.y45 = this.IfIsMoreThan22(this.n7 + this.y44);
        },

        TheY46() {
            this.y46 = this.IfIsMoreThan22(this.y43 + this.y44);
        },

        TheY47() {
            this.y47 = this.IfIsMoreThan22(this.y43 + this.n8);
        },

        TheY48() {
            this.y48 = this.IfIsMoreThan22(this.y43 + this.y47);
        },

        TheY49() {
            this.y49 = this.IfIsMoreThan22(this.n8 + this.y47);
        },

        TheY50() {
            this.y50 = this.IfIsMoreThan22(this.n8 + this.n1);
        },

        TheY51() {
            this.y51 = this.IfIsMoreThan22(this.n8 + this.y50);
        },

        TheY52() {
            this.y52 = this.IfIsMoreThan22(this.n8 + this.y51);
        },

        TheY53() {
            this.y53 = this.IfIsMoreThan22(this.y50 + this.y51);
        },

        TheY54() {
            this.y54 = this.IfIsMoreThan22(this.y50 + this.n1);
        },

        TheY55() {
            this.y55 = this.IfIsMoreThan22(this.n1 + this.y54);
        },

        TheY56() {
            this.y56 = this.IfIsMoreThan22(this.y50 + this.y54);
        },

        TheN33() {
            this.n33 = this.n1;
        },

        TheN34() {
            this.n34 = this.n3;
        },

        TheN35() {
            this.n35 = this.IfIsMoreThan22(this.n3 + this.n1);
        },

        TheN36() {
            this.n36 = this.n9;
        },

        TheN37() {
            this.n37 = this.n11;
        },

        TheN38() {
            this.n38 = this.IfIsMoreThan22(this.n9 + this.n11);
        },

        TheN39() {
            this.n39 = this.n17;
        },

        TheN40() {
            this.n40 = this.n19;
        },

        TheN41() {
            this.n41 = this.IfIsMoreThan22(this.n19 + this.n17);
        },

        TheN42() {
            this.n42 = this.n25;
        },

        TheN43() {
            this.n43 = this.n26;
        },

        TheN44() {
            this.n44 = this.IfIsMoreThan22(this.n26 + this.n25);
        },

        TheN45() {
            this.n45 = this.n30;
        },

        TheN46() {
            this.n46 = this.n30;
        },

        TheN47() {
            this.n47 = this.IfIsMoreThan22(this.n30 + this.n30);
        },

        TheN48() {
            this.n48 = this.n21;
        },

        TheN49() {
            this.n49 = this.n15;
        },

        TheN50() {
            this.n50 = this.IfIsMoreThan22(this.n21 + this.n15);
        },

        TheN51() {
            this.n51 = this.n5;
        },

        TheN52() {
            this.n52 = this.n7;
        },

        TheN53() {
            this.n53 = this.IfIsMoreThan22(this.n5 + this.n7);
        },

        TheN54() {
            this.n54 = this.IfIsMoreThan22(this.n1 + this.n9 + this.n17 + this.n25 + this.n30 + this.n21 + this.n5);
        },

        TheN55() {
            this.n55 = this.IfIsMoreThan22(this.n3 + this.n11 + this.n19 + this.n26 + this.n30 + this.n15 + this.n7);
        },

        TheN56() {
            this.n56 = this.IfIsMoreThan22(this.n35 + this.n38 + this.n41 + this.n44 +  this.n47  + this.n50 + this.n53 );
        },

        TheN57() {
            this.n57 = this.IfIsMoreThan22(this.n3 + this.n7);
        },


        TheN59() {
            this.n59 = this.IfIsMoreThan22(this.n1 + this.n5);
        },

        TheN58() {
            this.n58 = this.IfIsMoreThan22(this.n59 + this.n57);
        },


        TheN60() {
            this.n60 = this.IfIsMoreThan22(this.n2 + this.n6);
        },


        TheN62() {
            this.n62 = this.IfIsMoreThan22(this.n4 + this.n8);
        },

        TheN61() {
            this.n61 = this.IfIsMoreThan22(this.n60 + this.n62);
        },


        TheN63() {
            this.n63 = this.IfIsMoreThan22(this.n58 + this.n61);
        },

        TheN64() {
            this.n64 = this.IfIsMoreThan22(this.n2 + this.n6);
        },

        TheN65() {
            this.n65 = this.IfIsMoreThan22(this.n4 + this.n8);
        },

        Calculat() {
            this.open = false,
                this.open1 = false;
            this.open2 = false;
            this.open3 = false;
            this.open4 = false;
            this.open5 = false;
            this.open6 = false;
            this.open7 = false;
            this.open8 = false;
            //this.isRestult = true;
            this.showResult = true;
            this.TheN1();
            this.TheN5();
            this.TheN3();
            this.TheN7();
            this.TheD();
            this.TheN17();
            this.TheN19();
            this.TheN41();
            this.TheN21();
            this.TheN9();
            this.TheN11();
            this.TheN13();
            this.TheN2();
            this.TheN4();
            this.TheN6();
            this.TheN8();
            this.TheN26();
            this.TheN25();
            this.TheN31();
            this.TheN32();
            this.TheN18();
            this.TheN20();
            this.TheN12();
            this.TheN22();
            this.TheN14();
            this.TheN24();
            this.TheN16();
            this.TheN10();
            this.TheN15();
            this.TheN23();
            this.TheN28();
            this.TheN27();
            this.TheN29();
            this.TheY1();
            this.TheY2();
            this.TheY3();
            this.TheY4();
            this.TheY5();
            this.TheY7();
            this.TheY6();
            this.TheY8();
            this.TheY9();
            this.TheY10();
            this.TheY11();
            this.TheY12();
            this.TheY13();
            this.TheY14();
            this.TheY15();
            this.TheY16();
            this.TheY17();
            this.TheY18();
            this.TheY19();
            this.TheY20();
            this.TheY21();
            this.TheY22();
            this.TheY23();
            this.TheY24();
            this.TheY25();
            this.TheY26();
            this.TheY27();
            this.TheY28();
            this.TheY29();
            this.TheY30();
            this.TheY31();
            this.TheY32();
            this.TheY33();
            this.TheY34();
            this.TheY35();
            this.TheY36();
            this.TheY37();
            this.TheY38();
            this.TheY39();
            this.TheY40();
            this.TheY41();
            this.TheY42();
            this.TheY43();
            this.TheY44();
            this.TheY45();
            this.TheY46();
            this.TheY47();
            this.TheY48();
            this.TheY49();
            this.TheY50();
            this.TheY51();
            this.TheY52();
            this.TheY53();
            this.TheY54();
            this.TheY55();
            this.TheY56();
            this.TheN33();
            this.TheN34();
            this.TheN35();
            this.TheN36();
            this.TheN37();
            this.TheN38();
            this.TheN39();
            this.TheN40();
            this.TheN41();
            this.TheN42();
            this.TheN43();
            this.TheN44();
            this.TheN45();
            this.TheN46();
            this.TheN47();
            this.TheN48();
            this.TheN49();
            this.TheN50();
            this.TheN51();
            this.TheN52();
            this.TheN53();
            this.TheN54();
            this.TheN55();
            this.TheN56();
            this.TheN57();
            this.TheN59();
            this.TheN58();
            this.TheN60();
            this.TheN62();
            this.TheN61();
            this.TheN63();
            this.TheN64();
            this.TheN65();

        },
        showResultPlease() {
            if (this.email !== '') {
                this.isRestult = true;
            }
            else {
                alert('Por favor, informa seu e-mail');
            }
        },

    },
    beforeMount() {
        this.Calculat();
    },

}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Forum&display=swap');
 
input[type="date"]::-webkit-calendar-picker-indicator {
   
  opacity: 0;
  
}
input[type="date"] {
    position:relative;
}
 
input[type="date"]::-webkit-calendar-picker-indicator:hover {
  opacity: 0
}

section {

    font-family: "Forum", serif;
}

.table {
    min-width: 500px;
}

.explanation-item ul {
    list-style: inside !important;
}

.explanation-item p {
    font-size: 18px;
}

li {
    position: relative;
    margin-right: 20px !important;
    display: block;
    font-size: 15px !important;
}

.explanation-item li::before {
    width: 4px;
    height: 4px;
    display: block;
    position: absolute;
    background: #ccc;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 50%;
}

.sectionopener span {
    font-size: 20px;
}

.resultItem {
    transition: all .1s;
    background: #f8f8f8;

}

.resultItem.active {

    padding-bottom: 40px;
}

.resultItem {
    background: #fafbfc;
}

.sectionopener items-center span {
    font-size: 24px;
    font-weight: bold;
}

div,
p,
span {
    font-family: "Forum", serif;
}

.transimage {
    bottom: 2px !important;
    right: 1px !important;
}


select {
    background-color: #F6F4F7 !important;
    border-radius: 6px !Important;
}

@media screen and (max-width:1200px) {
    .obch {
        flex: 0 0 100% !important;
        padding: 10px;
    }

    .transimage {
        bottom: 5px !important;
    }

}


#formMatrix h3 {
    text-align: center;
}


.obch .trans,
.obch .trans>div {
    border-radius: 50%;
    display:flex;
    justify-content:center;
    align-items:center;
}

.container {
    width: 1280px;
    max-width: 100%;
    margin: 0 auto;
}

.birthdate {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 90px;
    justify-content: center;
}

.birthdate-item {
    display: flex;
    flex-direction: column;
    gap: 3px;
    max-width: 120px;
}

.transimage {
    width: 101%;
    z-index: 0;
    position: relative;

}

.result p {
    margin-bottom: 18px;
}

.trans span {
    font-size: 16px;
}

.gender-option.active {
    background:#C1A3BD;
}

#n1 div,
    #n3 div,
    #n5 div,
    #n7 div,
    #n30 div,
    #n2,
    #n4,
    #n6,
    #n8 {
        border-width: 3px !important;
    }

    #n9 div,
    #n17 div,
    #n25 div, 
    #n31,
    #n32,
    #n10 ,
    #n18,
    #n11 div, 
    #n19 div,
    #n26 div,
    #n12 ,
    #n20, 
    #n21 div,
    #n13,
    #n24,
    #n16,
    #n23 div,
    #n15,
    #n29,
    #n28,
    #n27,
    #n22, 
    #n14   {
        border-width: 2px !important;
    }

@media screen and (max-width:1335px) {
    .trans span {
        font-size: 15px;
    }
}

@media screen and (max-width:1200px) {
    .obch {
        flex: 0 0 100%;
        padding: 2px;
    }

    .rightblock {
        flex: 0 0 100%;
    }

    .trans span {
        font-size: 16px;
    }

    .table {
        min-width: 400px;
    }

    .trans>div {
        overflow: hidden;
    }

    .trans>div>span {
        display: block !important;

    }

    #n1 div,
    #n3 div,
    #n5 div,
    #n7 div,
    #n30 div,
    #n2,
    #n4,
    #n6,
    #n8 {
        border-width: 1px !important;
    }

    #n9 div,
    #n17 div,
    #n25 div, 
    #n31,
    #n32,
    #n10 ,
    #n18,
    #n11 div, 
    #n19 div,
    #n26 div,
    #n12 ,
    #n20, 
    #n21 div,
    #n13,
    #n24,
    #n16,
    #n23 div,
    #n15,
    #n29,
    #n28,
    #n27,
    #n22, 
    #n14   {
        border-width: 1px !important;
    }

}

#n1 span,
#n3 span,
#n5 span,
#n7 span,
#n30 span,
#n2 span,
#n4 span,
#n6 span,
#n8 span {
    font-size: 24px
}



@media screen and (max-width:600px) {
    .chakras>div {
        padding-left: 20px;
    }



    .trans span {
        font-size: 15px;
        position: relative;
        
    }

    .obch .trans span {
        font-size: 12px;
        top: 0
    }

    #n1 span,
    #n3 span,
    #n5 span,
    #n7 span,
    #n30 span,
    #n2 span,
    #n4 span,
    #n6 span,
    #n8 span {
        font-size: 16px;
        position: relative;
        bottom: 1px;
    }

    .transimage {
        width: 100%;
        z-index: 0;
        position: relative;
        bottom: 0 !important;
        right: 1px;
    }

    table {
        margin-left: auto;
        margin-right: auto;
        width: 90%;
        margin: 0 auto;
    }

}

@media screen and (max-width:470px) {

    .obch .trans span {
        font-size:13px;
       

    }

    .table {
        min-width: 350px;
    }

}

.matrix-of-destiny {
    width: 800px;
    max-width: 100%;
    margin: 50px auto;
    background-color: #fff;
    padding: 30px;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h1 {
    text-align: left;
    margin-bottom: 20px;
    color: #442a69;
    /* zmiana koloru na #442a69 */
    display: none;
    /* usuwanie tytułu */
}

#matrix-form {
    margin-bottom: 30px;
}

.mod-form-row {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
}

.mod-form-col {
    flex-basis: calc(33.33% - 20px);
    margin-right: 20px;
    position: relative;
    min-width: 0;
    box-sizing: border-box;
}

.mod-form-label {
    display: block;
    margin-bottom: 5px;
    color: #442a69;
    /* zmiana koloru na #442a69 */
    font-weight: bold;
}

.mod-form-input {
    display: block;
    width: 100%;
    padding: 10px;
    border: 1px solid #f6f4f7;
    border-radius: 5px;
    background-color: #f6f4f7;
    font-size: 16px;
    line-height: 1.5;
    color: #333;
    height: 40px;
}

.gender-select {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.gender-title {
    font-size: 16px;
    color: #442a69;
    /* zmiana koloru na #442a69 */
    margin-bottom: 5px;
}

.gender-options {
    display: flex;

}

.gender-option {
    display: flex;
    align-items: center;
    background-color: #f6f4f7;
    border: 1px solid #f6f4f7;
    border-radius: 5px;
    padding: 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-right: 10px;
    height: 40px;
    gap: 8px;
}

.gender-option:hover {
    background-color: #e5e5f8;
}

.gender-option i {
    font-size: 20px;
    color: #442a69;
    /* zmiana koloru na #442a69 */
    margin-right: 5px;
}

.mod-form-button {
    display: block;
    width: 120px;
    padding: 8px;
    border: none;
    border-radius: 5px;
    background-color: #442A69;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-top: 30px;
    height:40px;
}

.mod-form-button:hover {
    background-color: #644c85;
    color: white;
}

/* Responsive Styling */
@media only screen and (max-width: 600px) {
    .mod-form-col {
        flex-basis: 100%;
        margin-right: 0;
    }

    .matrix-of-destiny { 
        max-width:90%;
    }

    .gender-title {
        margin-top: 15px;
    }
}
</style>
